(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefa41"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefa41"] = parcelRequire;
}
parcelRequire.register("lRwbt", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $fea7834949000af6$export$6503ec6e8aabbaf; }, function (v) { return $fea7834949000af6$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $fea7834949000af6$export$f7ad0328861e2f03; }, function (v) { return $fea7834949000af6$export$f7ad0328861e2f03 = v; });
var $fea7834949000af6$export$6503ec6e8aabbaf;
var $fea7834949000af6$export$f7ad0328861e2f03;
"use strict";
var $fea7834949000af6$var$mapping = {};
function $fea7834949000af6$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$fea7834949000af6$var$mapping[keys[i]] = pairs[keys[i]];
}
function $fea7834949000af6$var$resolve(id) {
    var resolved = $fea7834949000af6$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$fea7834949000af6$export$6503ec6e8aabbaf = $fea7834949000af6$var$register;
$fea7834949000af6$export$f7ad0328861e2f03 = $fea7834949000af6$var$resolve;

});

parcelRequire.register("gAvq4", function(module, exports) {



module.exports = (parcelRequire("lqKqf"))((parcelRequire("lW9uW")).getBundleURL("3MPdb") + (parcelRequire("lRwbt")).resolve("jvVOn")).then(()=>parcelRequire("h2o9N"));

});
parcelRequire.register("lqKqf", function(module, exports) {
"use strict";

var $eAgtN = parcelRequire("eAgtN");
module.exports = $eAgtN(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRequire.register("eAgtN", function(module, exports) {
"use strict";
var $a9e135f99db90e26$var$cachedBundles = {};
var $a9e135f99db90e26$var$cachedPreloads = {};
var $a9e135f99db90e26$var$cachedPrefetches = {};
function $a9e135f99db90e26$var$getCache(type) {
    switch(type){
        case "preload":
            return $a9e135f99db90e26$var$cachedPreloads;
        case "prefetch":
            return $a9e135f99db90e26$var$cachedPrefetches;
        default:
            return $a9e135f99db90e26$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a9e135f99db90e26$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRequire.register("lW9uW", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $ff8661dc6162b7fb$export$bdfd709ae4826697; }, function (v) { return $ff8661dc6162b7fb$export$bdfd709ae4826697 = v; });
$parcel$export(module.exports, "getOrigin", function () { return $ff8661dc6162b7fb$export$5a759dc7a1cfb72a; }, function (v) { return $ff8661dc6162b7fb$export$5a759dc7a1cfb72a = v; });
var $ff8661dc6162b7fb$export$bdfd709ae4826697;
var $ff8661dc6162b7fb$export$c9e73fbda7da57b6;
var $ff8661dc6162b7fb$export$5a759dc7a1cfb72a;
"use strict";
var $ff8661dc6162b7fb$var$bundleURL = {};
function $ff8661dc6162b7fb$var$getBundleURLCached(id) {
    var value = $ff8661dc6162b7fb$var$bundleURL[id];
    if (!value) {
        value = $ff8661dc6162b7fb$var$getBundleURL();
        $ff8661dc6162b7fb$var$bundleURL[id] = value;
    }
    return value;
}
function $ff8661dc6162b7fb$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ff8661dc6162b7fb$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $ff8661dc6162b7fb$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $ff8661dc6162b7fb$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$ff8661dc6162b7fb$export$bdfd709ae4826697 = $ff8661dc6162b7fb$var$getBundleURLCached;
$ff8661dc6162b7fb$export$c9e73fbda7da57b6 = $ff8661dc6162b7fb$var$getBaseURL;
$ff8661dc6162b7fb$export$5a759dc7a1cfb72a = $ff8661dc6162b7fb$var$getOrigin;

});


var $2c9f2ed147e1d8d1$exports = {};

(parcelRequire("lRwbt")).register(JSON.parse('{"3MPdb":"chat-loader.js","jvVOn":"call-data.b80c1a49.js"}'));

const $3ee9d18e461ecca7$var$doGet = ({ chatServiceUrl: chatServiceUrl, token: token, path: path, raw: raw })=>{
    return $3ee9d18e461ecca7$var$doFetch({
        chatServiceUrl: chatServiceUrl,
        token: token,
        path: path,
        method: "GET",
        raw: raw
    });
};
const $3ee9d18e461ecca7$export$872f4f09fb3b16a3 = ({ chatServiceUrl: chatServiceUrl, token: token, path: path, body: body, raw: raw })=>{
    return $3ee9d18e461ecca7$var$doFetch({
        chatServiceUrl: chatServiceUrl,
        token: token,
        path: path,
        method: "POST",
        body: body,
        raw: raw
    });
};
const $3ee9d18e461ecca7$var$doFetch = ({ chatServiceUrl: chatServiceUrl, token: token, path: path, method: method, body: body, raw: raw })=>{
    return fetch(`https://${chatServiceUrl}${path}`, {
        method: method,
        headers: {
            "Content-Type": "application/vnd.api+json",
            Authorization: `Bearer ${token}`,
            Pragma: "no-cache"
        },
        body: JSON.stringify(body)
    }).then((response)=>{
        if (raw) return response;
        return response.json();
    });
};
const $3ee9d18e461ecca7$export$6efe264be9505de7 = (command, params)=>{
    window.parent.postMessage({
        command: command,
        params: params
    }, "*");
};
const $3ee9d18e461ecca7$var$sendEvent = ({ conversationID: conversationID, event_attributes: event_attributes, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $3ee9d18e461ecca7$export$872f4f09fb3b16a3({
        path: `/conversations/${conversationID}/events`,
        token: token,
        chatServiceUrl: chatServiceUrl,
        body: {
            data: {
                type: "conversation_events",
                attributes: event_attributes
            }
        }
    });
};
const $3ee9d18e461ecca7$export$a2ff1144002a6147 = ({ conversationID: conversationID, chatServiceUrl: chatServiceUrl, token: token })=>{
    return $3ee9d18e461ecca7$var$doGet({
        chatServiceUrl: chatServiceUrl,
        token: token,
        path: `/conversations/${conversationID}?include=participants,tags`
    });
};
const $3ee9d18e461ecca7$export$bade1af6f5e96e0c = ({ token: token, chatServiceUrl: chatServiceUrl, searchText: searchText, sortOrder: sortOrder, searchFilter: searchFilter, page: page, pageSize: pageSize, searchType: searchType })=>{
    const path = "/conversations?";
    const params = new URLSearchParams();
    if (searchText) params.set("filter[search]", searchText);
    if (searchType) params.set("filter[search_type]", searchType);
    switch(searchFilter){
        case "mine_open":
            params.set("filter[status]", "open");
            params.set("filter[participants]", "mine");
            break;
        case "mine":
            params.set("filter[participants]", "mine");
            break;
        case "all_open":
            params.set("filter[status]", "open");
            params.set("filter[participants]", "all");
            break;
        case "all":
            params.set("filter[participants]", "all");
            params.set("filter[status]", "not_prompt");
            break;
        case "unclaimed":
            params.set("filter[participants]", "unclaimed");
            params.set("filter[status]", "not_prompt");
            break;
        case "my_notes":
            params.set("filter[notes]", "mine");
            params.set("filter[participants]", "mine");
            break;
        case "my_unresolved_notes":
            params.set("filter[notes]", "unresolved");
            params.set("filter[participants]", "mine");
            break;
    }
    params.set("sort_order", sortOrder);
    params.set("include", "read_receipt");
    if (page && pageSize) {
        params.set("page[number]", page);
        params.set("page[size]", pageSize);
    }
    return $3ee9d18e461ecca7$var$doGet({
        chatServiceUrl: chatServiceUrl,
        token: token,
        path: path + params.toString()
    });
};
const $3ee9d18e461ecca7$export$26dce2c43b43b8bd = ({ conversationID: conversationID, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $3ee9d18e461ecca7$var$doGet({
        path: `/conversations/${conversationID}/events`,
        chatServiceUrl: chatServiceUrl,
        token: token
    });
};
const $3ee9d18e461ecca7$export$c7ff47b8a892cacd = ({ first_message: first_message, prompt: prompt, chatServiceUrl: chatServiceUrl, token: token, url: url, referrer: referrer, route_to_user_id: route_to_user_id, page_title: page_title })=>{
    return $3ee9d18e461ecca7$export$872f4f09fb3b16a3({
        path: "/conversations/visitor_initiated",
        chatServiceUrl: chatServiceUrl,
        token: token,
        body: {
            data: {
                type: "conversations",
                attributes: {
                    body: first_message,
                    kind: "chat",
                    prompt: prompt,
                    start_url: url,
                    referrer: referrer,
                    page_title: page_title,
                    route_to_user_id: route_to_user_id
                }
            }
        }
    });
};
const $3ee9d18e461ecca7$export$3f208634044a8339 = ({ event_id: event_id, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $3ee9d18e461ecca7$export$872f4f09fb3b16a3({
        path: `/calendar_drops/${event_id}`,
        chatServiceUrl: chatServiceUrl,
        token: token
    });
};
const $3ee9d18e461ecca7$export$a8856a0509e3da2f = ({ buttonID: buttonID, conversationID: conversationID, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $3ee9d18e461ecca7$export$872f4f09fb3b16a3({
        chatServiceUrl: chatServiceUrl,
        token: token,
        path: "/conversations:button_push",
        body: {
            data: {
                attributes: {
                    button_id: buttonID,
                    conversation_id: conversationID
                }
            }
        }
    });
};
const $3ee9d18e461ecca7$export$20a8a3976e8c41f = ({ token: token, agentID: agentID, chatServiceUrl: chatServiceUrl, direct: direct })=>{
    return $3ee9d18e461ecca7$export$872f4f09fb3b16a3({
        chatServiceUrl: chatServiceUrl.split("/api/")[0],
        body: {
            data: {
                attributes: {
                    token: token,
                    agent_id: agentID,
                    direct: direct
                }
            }
        },
        path: `/api/core/web_voice/${agentID}/call`
    });
};
const $3ee9d18e461ecca7$export$97252688ea203707 = ({ event_id: event_id, start: start, end: end, startTimestamp: startTimestamp, endTimestamp: endTimestamp, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $3ee9d18e461ecca7$export$872f4f09fb3b16a3({
        raw: true,
        chatServiceUrl: chatServiceUrl,
        token: token,
        path: "/calendar_events",
        body: {
            data: {
                attributes: {
                    scheduled_start: start,
                    scheduled_end: end,
                    scheduled_start_timestamp: startTimestamp,
                    scheduled_end_timestamp: endTimestamp
                },
                relationships: {
                    calendar_drop: {
                        data: {
                            type: "conversation_events",
                            id: event_id
                        }
                    }
                }
            }
        }
    }).then((response)=>{
        if (response.status >= 400 && response.status < 500) return false;
        else return response.json();
    });
};
const $3ee9d18e461ecca7$export$9541b074d75dd2a8 = ({ calendarDropEventID: calendarDropEventID, phone: phone, reminderTime: reminderTime, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $3ee9d18e461ecca7$export$872f4f09fb3b16a3({
        token: token,
        chatServiceUrl: chatServiceUrl,
        path: "/calendar_events/text_reminder",
        body: {
            data: {
                attributes: {
                    phone: phone,
                    reminder_time: reminderTime
                },
                relationships: {
                    calendar_drop: {
                        data: {
                            type: "conversation_events",
                            id: calendarDropEventID
                        }
                    }
                }
            }
        }
    });
};
const $3ee9d18e461ecca7$export$aada62336c04439a = ({ calendarDropEventID: calendarDropEventID, email: email, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $3ee9d18e461ecca7$export$872f4f09fb3b16a3({
        token: token,
        chatServiceUrl: chatServiceUrl,
        path: "/calendar_events/email_reminder",
        body: {
            data: {
                attributes: {
                    email: email
                },
                relationships: {
                    calendar_drop: {
                        data: {
                            type: "conversation_events",
                            id: calendarDropEventID
                        }
                    }
                }
            }
        }
    });
};
const $3ee9d18e461ecca7$export$22b2e2ebe09465e3 = ({ rating_event_id: rating_event_id, rating: rating, ratingType: ratingType, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $3ee9d18e461ecca7$export$872f4f09fb3b16a3({
        token: token,
        chatServiceUrl: chatServiceUrl,
        path: "/conversation_rating_events",
        body: {
            data: {
                attributes: {
                    ratingType: ratingType,
                    rating: rating
                },
                relationships: {
                    rating_drop: {
                        data: {
                            type: "conversation_events",
                            id: rating_event_id
                        }
                    }
                }
            }
        }
    });
};
const $3ee9d18e461ecca7$export$f9dce390e0985015 = ({ flow_id: flow_id, token: token, chatServiceUrl: chatServiceUrl, page_url: page_url, referrer: referrer, page_title: page_title })=>{
    console.log("attempting to request bot flow: ", flow_id);
    return $3ee9d18e461ecca7$export$872f4f09fb3b16a3({
        token: token,
        chatServiceUrl: chatServiceUrl,
        path: "/conversations",
        body: {
            data: {
                type: "conversations",
                attributes: {
                    body: "",
                    kind: "bot_trigger",
                    data: {
                        flow_id: flow_id
                    },
                    status: "prompt",
                    start_url: page_url,
                    referrer: referrer,
                    page_title: page_title
                }
            }
        }
    });
};
const $3ee9d18e461ecca7$export$7a9befad52997cab = ({ botID: botID, token: token, chatServiceUrl: chatServiceUrl, page_url: page_url, page_title: page_title, referrer: referrer, preview: preview, submissionID: submissionID })=>{
    return $3ee9d18e461ecca7$export$872f4f09fb3b16a3({
        path: "/conversations",
        token: token,
        chatServiceUrl: chatServiceUrl,
        body: {
            data: {
                type: "conversations",
                attributes: {
                    body: "",
                    kind: "bot_trigger",
                    data: {
                        bot_id: botID,
                        submission_id: submissionID
                    },
                    status: "prompt",
                    start_url: page_url,
                    page_title: page_title,
                    referrer: referrer,
                    preview: preview || false
                }
            }
        }
    });
};
const $3ee9d18e461ecca7$export$6cd74db52a94a51f = ({ conversationID: conversationID, body: body, data: data, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $3ee9d18e461ecca7$var$sendEvent({
        conversationID: conversationID,
        event_attributes: {
            body: body,
            kind: "chat",
            data: data || {}
        },
        token: token,
        chatServiceUrl: chatServiceUrl
    });
};
const $3ee9d18e461ecca7$export$d27c9815c6b3753f = ({ conversationID: conversationID, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $3ee9d18e461ecca7$var$sendEvent({
        conversationID: conversationID,
        event_attributes: {
            body: "",
            kind: "type"
        },
        token: token,
        chatServiceUrl: chatServiceUrl
    });
};
const $3ee9d18e461ecca7$export$2c28f69fbea80beb = ({ conversationID: conversationID, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $3ee9d18e461ecca7$var$sendEvent({
        conversationID: conversationID,
        event_attributes: {
            body: "",
            kind: "halt"
        },
        token: token,
        chatServiceUrl: chatServiceUrl
    });
};
const $3ee9d18e461ecca7$export$21f305c035a18ae3 = ({ chatServiceUrl: chatServiceUrl, token: token, pageURL: pageURL, packetCode: packetCode, referrer: referrer })=>{
    const params = new URLSearchParams();
    params.append("filter[referrer]", referrer);
    params.append("filter[page_url]", pageURL);
    params.append("filter[packet_code]", packetCode);
    return $3ee9d18e461ecca7$var$doGet({
        path: "/welcome_packet?" + params.toString(),
        chatServiceUrl: chatServiceUrl,
        token: token,
        raw: true
    }).then((response)=>{
        if (response.status === 200) return response.json();
        console.log("non 200 returned:", response.status);
        return false;
    }).then((welcome_packet)=>{
        if (!welcome_packet) return false;
        return welcome_packet.data.attributes;
    });
};
const $3ee9d18e461ecca7$var$setLocalItem = (k, v)=>{
    try {
        var item = {
            value: v,
            expires: Date.now() + 3600000
        };
        window.localStorage.setItem(k, JSON.stringify(item));
        $3ee9d18e461ecca7$export$8a8216c44337cd5(k, v);
    } catch (e) {
    // pass
    }
};
const $3ee9d18e461ecca7$export$8a8216c44337cd5 = (k, v)=>{
    try {
        window.sessionStorage.setItem(k, v);
    } catch (e) {
    // pass
    }
};
const $3ee9d18e461ecca7$var$getLocalItem = (k)=>{
    try {
        var item = window.localStorage.getItem(k);
        if (!item) return null;
        var visitObj = JSON.parse(item);
        if (visitObj["expires"] < Date.now()) {
            window.localStorage.removeItem(k);
            return null;
        }
        if (!window.sessionStorage.getItem(k)) {
            window.localStorage.removeItem(k);
            $3ee9d18e461ecca7$var$setLocalItem(k, visitObj["value"]);
            return visitObj["value"];
        }
        return visitObj["value"];
    } catch (e) {
    // pass
    }
    return null;
};
const $3ee9d18e461ecca7$export$f92dfeb71e9bb569 = (k)=>{
    try {
        return window.sessionStorage.getItem(k);
    } catch (e) {
    // pass
    }
    return null;
};
const $3ee9d18e461ecca7$export$fd98ba27f2ec095e = (k)=>{
    let i = $3ee9d18e461ecca7$export$f92dfeb71e9bb569(k);
    if (i) return parseInt(i);
    return null;
};
const $3ee9d18e461ecca7$export$fe2d9b4e03920b4c = (k)=>{
    try {
        window.sessionStorage.removeItem(k);
    } catch (e) {
    // pass
    }
};
const $3ee9d18e461ecca7$var$crypto = window.crypto || window.msCrypto;
const $3ee9d18e461ecca7$export$6473347ac50c95ee = (byte_count)=>{
    const array_values = new Uint8Array(byte_count);
    $3ee9d18e461ecca7$var$crypto.getRandomValues(array_values);
    const hex = [];
    for(let j = 0; j < array_values.length; j++){
        const num = array_values[j];
        let i = num.toString(16) // use base 16 (hexadecimal)
        ;
        if (i.length < 2) i = "0" + i // ensure each byte is represented by two characters
        ;
        hex.push(i);
    }
    return hex.join("");
};
const $3ee9d18e461ecca7$export$30c606e92a482586 = (packet_code)=>{
    if (!packet_code) return undefined;
    let visitID = $3ee9d18e461ecca7$var$getLocalItem(`visit-id-${packet_code}`);
    if (!visitID) {
        visitID = $3ee9d18e461ecca7$export$6473347ac50c95ee(16);
        $3ee9d18e461ecca7$var$setLocalItem(`visit-id-${packet_code}`, visitID);
    }
    return visitID;
};
const $3ee9d18e461ecca7$export$6853a7e3417d845d = ({ chatServiceUrl: chatServiceUrl, token: token })=>{
    if (!$3ee9d18e461ecca7$export$f92dfeb71e9bb569("unwanted-emails")) $3ee9d18e461ecca7$var$doGet({
        path: "/unwanted",
        chatServiceUrl: chatServiceUrl,
        token: token
    }).then((response)=>{
        $3ee9d18e461ecca7$export$6efe264be9505de7("unwanted_emails", response.data.attributes);
    });
};
const $3ee9d18e461ecca7$export$897f1ec3b6f3514a = ({ chatServiceUrl: chatServiceUrl, token: token, form_id: form_id, pageURL: pageURL, pageTitle: pageTitle, visitID: visitID })=>{
    const params = new URLSearchParams();
    params.append("page_url", pageURL);
    params.append("page_title", pageTitle);
    params.append("visit_id", visitID);
    $3ee9d18e461ecca7$var$doGet({
        path: `/forms/${form_id}/fill?${params.toString()}`,
        chatServiceUrl: chatServiceUrl,
        token: token
    }).then((response)=>{
        $3ee9d18e461ecca7$export$6efe264be9505de7("form_fill", {
            id: form_id,
            form_fill: response.data.attributes
        });
    });
};



const $c41a06a80f487f1e$var$setupSignalsVisualizer = async ()=>{
    const { getFakeData: getFakeData } = await (parcelRequire("gAvq4"));
    let talking = false;
    let talkingTimeout = null;
    const wrapperDiv = document.getElementById("w-node-fb287d71-6968-5457-7aaa-1d717d49b346-7d49b342");
    if (wrapperDiv) {
        const canvasElement = document.createElement("canvas");
        const TWO_PI = Math.PI * 2;
        canvasElement.id = "waveform";
        canvasElement.width = 300;
        canvasElement.height = 300;
        canvasElement.style.position = "absolute";
        canvasElement.style.left = "139px";
        canvasElement.style.top = "19px";
        wrapperDiv.parentElement.parentElement.parentElement.appendChild(canvasElement);
        const visualizeCallCircle = (dataArray)=>{
            const canvas = canvasElement;
            const ctx = canvas.getContext("2d");
            const width = canvas.width;
            const height = canvas.height;
            const min = Math.min(...dataArray);
            const max = Math.max(...dataArray);
            if (talking && min === 0 && max === 0) dataArray = getFakeData();
            else if (Math.abs(min - max) < 0.1) {
                canvasElement.style.display = "none";
                return;
            }
            canvasElement.style.display = "";
            for(let i = 0; i < dataArray.length; i++){
                let v = dataArray[i];
                v = (v + 1) * (width / 2 - .2 * width);
                dataArray[i] = v;
            }
            ctx.lineWidth = 0.5;
            ctx.clearRect(0, 0, width, height);
            let cX = width / 2;
            let cY = height / 2;
            let radianAdd = TWO_PI / dataArray.length;
            let radian = 0;
            ctx.fillStyle = "#21d2f2";
            for(let i = 0; i < dataArray.length; i++){
                let v = dataArray[i];
                let x = v * Math.cos(radian) + cX;
                let y = v * Math.sin(radian) + cY;
                ctx.beginPath();
                ctx.arc(x, y, 0.5, 0, TWO_PI, false);
                ctx.fill();
                radian += radianAdd;
            }
        };
        document.addEventListener("signals:webcall", function(event) {
            const data = event.detail.evt_data.params;
            switch(event.detail.evt_type){
                case "webcall:agent_start_talking":
                    if (talkingTimeout !== null) {
                        clearTimeout(talkingTimeout);
                        talkingTimeout = null;
                    }
                    talking = true;
                    break;
                case "webcall:agent_stop_talking":
                    talkingTimeout = setTimeout(()=>{
                        talking = false;
                    }, 600);
                    break;
                case "webcall:audio":
                    visualizeCallCircle(data);
                    break;
                case "webcall:call_ended":
                    talking = false;
                    canvasElement.style.display = "none";
                    break;
                case "webcall:update":
                    break;
                case "webcall:metadata":
                    break;
            }
        });
    }
};
/* eslint-disable no-prototype-builtins */ window.ChatFunnels = function(params) {
    let chat_window;
    let chat_el;
    let chat_el_wrap;
    let has_activated = false;
    const packet_code = params.packet_code;
    let app_url = params.app_url;
    let chatServiceUrl = params.service_address;
    if (packet_code === "cb6dbb20bfbeee14b104c353779772ef78d549b2") {
        app_url = "https://beta.getsignals.ai/chat-client/";
        chatServiceUrl = "beta.getsignals.ai/api/chat-service/a";
        if (window.location.pathname !== "/trychad") $c41a06a80f487f1e$var$setupSignalsVisualizer();
    }
    const debug = params.debug || false;
    const siteTitle = window.document.title;
    const hideMode = params.hideMode || false;
    let page_load_id = null;
    let has_scrolled = false;
    let max_scroll_percent = 0;
    const triggers = {};
    let ga4_params = {};
    const identity = {
        first_name: "",
        last_name: "",
        email: ""
    };
    const page_change = {
        type: "page_change",
        url: "",
        page_title: "",
        plid: "",
        referrer: ""
    };
    let visualViewportSize = {};
    let visualViewportScrollTimeout = null;
    const mode = params.mode || "normal";
    const contentMode = [
        "content",
        "content-with-header"
    ].includes(mode);
    const chatInitReady = params.chatInitReady || (()=>{});
    const auto_load_bot_id = params.bot_id;
    const submissionID = params.submissionID;
    const parentElement = params.parentElement;
    const chatCompletelyReady = params.chatCompletelyReady;
    const preventCriteriaPrompts = params.preventCriteriaPrompts || false;
    const supportBot = params.supportBot || false;
    const body = document.querySelector("body");
    /**
     * Until "cookie end" comment, license:
     *
     * Copyright (c) Florian Hartmann, https://github.com/florian
     * Permission is hereby granted, free of charge, to any person obtaining
     * a copy of this software and associated documentation files (the
     * "Software"), to deal in the Software without restriction, including
     * without limitation the rights to use, copy, modify, merge, publish,
     * distribute, sublicense, and/or sell copies of the Software, and to
     * permit persons to whom the Software is furnished to do so, subject to
     * the following conditions:
     * 
     * The above copyright notice and this permission notice shall be
     * included in all copies or substantial portions of the Software.
     * 
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
     * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
     * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
     * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
     * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
     * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
     * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     **/ // eslint-disable-next-line
    const cookielib = function() {
        "use strict";
        var e = function() {
            return e.get.apply(e, arguments);
        };
        var t = e.utils = {
            isArray: Array.isArray || function(e) {
                return Object.prototype.toString.call(e) === "[object Array]";
            },
            isPlainObject: function(e) {
                return !!e && Object.prototype.toString.call(e) === "[object Object]";
            },
            toArray: function(e) {
                return Array.prototype.slice.call(e);
            },
            getKeys: Object.keys || function(e) {
                var t = [];
                var r = "";
                for(r in e)e.hasOwnProperty(r) && t.push(r);
                return t;
            },
            encode: function(e) {
                return String(e).replace(/[,;"\\=\s%]/g, function(e) {
                    return encodeURIComponent(e);
                });
            },
            decode: function(e) {
                return decodeURIComponent(e);
            },
            retrieve: function(e, t) {
                return e == null ? t : e;
            }
        };
        return e.defaults = {}, e.expiresMultiplier = 86400, e.set = function(e, r, i) {
            if (t.isPlainObject(e)) for(var n in e)e.hasOwnProperty(n) && this.set(n, e[n], r);
            else {
                var o = void 0 !== (i = t.isPlainObject(i) ? i : {
                    expires: i
                }).expires ? i.expires : this.defaults.expires || "";
                var s = typeof o;
                s === "string" && o !== "" ? o = new Date(o) : s === "number" && (o = new Date(+new Date() + 1e3 * this.expiresMultiplier * o)), o !== "" && "toUTCString" in o && (o = ";expires=" + o.toUTCString());
                var a = i.path || this.defaults.path;
                a = a ? ";path=" + a : "";
                var u = i.domain || this.defaults.domain;
                u = u ? ";domain=" + u : "";
                var c = i.secure || this.defaults.secure ? ";secure" : "";
                !1 === i.secure && (c = "");
                var l = i.sameSite || this.defaults.sameSite;
                l = l ? ";SameSite=" + l : "", i.sameSite === null && (l = ""), document.cookie = t.encode(e) + "=" + t.encode(r) + o + a + u + c + l;
            }
            return this;
        }, e.setDefault = function(r, i, n) {
            if (t.isPlainObject(r)) {
                for(var o in r)void 0 === this.get(o) && this.set(o, r[o], i);
                return e;
            }
            if (void 0 === this.get(r)) return this.set.apply(this, arguments);
        }, e.remove = function(e) {
            for(var r = 0, i = (e = t.isArray(e) ? e : t.toArray(arguments)).length; r < i; r++)this.set(e[r], "", -1);
            return this;
        }, e.removeSpecific = function(e, r) {
            if (!r) return this.remove(e);
            e = t.isArray(e) ? e : [
                e
            ], r.expires = -1;
            for(var i = 0, n = e.length; i < n; i++)this.set(e[i], "", r);
            return this;
        }, e.empty = function() {
            return this.remove(t.getKeys(this.all()));
        }, e.get = function(e, r) {
            var i = this.all();
            if (t.isArray(e)) {
                for(var n = {}, o = 0, s = e.length; o < s; o++){
                    var a = e[o];
                    n[a] = t.retrieve(i[a], r);
                }
                return n;
            }
            return t.retrieve(i[e], r);
        }, e.all = function() {
            if (document.cookie === "") return {};
            for(var e = document.cookie.split("; "), r = {}, i = 0, n = e.length; i < n; i++){
                var o = e[i].split("=");
                var s = t.decode(o.shift());
                var a = t.decode(o.join("="));
                r[s] = a;
            }
            return r;
        }, e.enabled = function() {
            if (navigator.cookieEnabled) return !0;
            var t = e.set("_", "_").get("_") === "_";
            return e.remove("_"), t;
        }, e;
    };
    const cookie = cookielib();
    /* cookie end */ function validateForm(form) {
        var is_valid = true;
        const form_inputs = form.elements;
        for(let j = 0; j < form_inputs.length; j++){
            const input = form_inputs[j];
            if (input.required) {
                if (!validateFieldValue(input.value)) {
                    console.log("htmx: invalid field", {
                        id: input.id,
                        name: input.name,
                        value: input.value
                    }, input);
                    is_valid = false;
                }
            }
        }
        return is_valid;
    }
    function validateFieldValue(value) {
        const valid = value !== "";
        if (!valid) console.log("htmx: invalid field value", {
            value: value
        });
        return valid;
    }
    function createInputErr(input, msg, isPhone = false) {
        input.style.borderColor = "red";
        let err_msg = window.document.getElementById(input.id + "-invalid");
        if (!err_msg) {
            err_msg = window.document.createElement("small");
            err_msg.setAttribute("id", input.id + "-invalid");
            err_msg.setAttribute("style", "color: red;");
            err_msg.innerHTML = msg;
            if (isPhone) input.parentNode.parentNode.appendChild(err_msg);
            else input.parentNode.appendChild(err_msg);
        } else err_msg.innerHTML = msg;
    }
    function removeInputErr(input, isPhone = false) {
        if (isPhone) input.style = "width: 100%;";
        else input.style = "";
        const err_msg = window.document.getElementById(input.id + "-invalid");
        if (err_msg) err_msg.parentNode.removeChild(err_msg);
    }
    function validatePhone(input, iti, phone) {
        if (phone == "" && input.required) {
            createInputErr(input, "This field is required", true);
            return false;
        }
        if (iti.isValidNumber() || phone == "") {
            removeInputErr(input, true);
            return true;
        } else {
            createInputErr(input, "Invalid phone number - please try again", true);
            return false;
        }
    }
    function validateEmail(input, email) {
        if (email == "") {
            createInputErr(input, "This field is required");
            return false;
        }
        let is_invalid = false;
        let invalid_msg = "";
        const email_split = email.split("@");
        if (email_split.length > 1) {
            const email_domain = email_split[1];
            const tldReg = /(\.[a-zA-Z]{2,})$/;
            if (!tldReg.test(email_domain)) {
                is_invalid = true;
                invalid_msg = "You must include a TLD in your email address (e.g. .com, .org, .net)";
            }
            const unwanted_emails = JSON.parse(window.sessionStorage.getItem("unwanted-emails") || "{}");
            var classes = input.classList;
            if (classes.contains("spam-unwanted") && unwanted_emails["spam"].length > 0 && !is_invalid) {
                if (unwanted_emails["spam"].includes(email_domain)) {
                    is_invalid = true;
                    invalid_msg = "You must enter a valid business email";
                }
            }
            if (classes.contains("non-business-unwanted") && unwanted_emails["personal"].length > 0 && !is_invalid) {
                if (unwanted_emails["personal"].includes(email_domain)) {
                    is_invalid = true;
                    invalid_msg = "You must enter a valid business email";
                }
            }
            if (classes.contains("blocked-domains-unwanted") && unwanted_emails["blocked"].length > 0 && !is_invalid) {
                if (unwanted_emails["blocked"].includes(email_domain)) {
                    is_invalid = true;
                    invalid_msg = "You must enter a valid business email";
                }
            }
            if (is_invalid) {
                createInputErr(input, invalid_msg);
                input.setCustomValidity(invalid_msg);
                return false;
            } else {
                removeInputErr(input);
                input.setCustomValidity("");
            }
        }
        if (input.validity.typeMismatch) {
            createInputErr(input, input.validationMessage);
            return false;
        } else if (!is_invalid) removeInputErr(input);
        return true;
    }
    function gatherFormData(form) {
        const form_inputs = form.elements;
        const data = {};
        for(let i = 0; i < form_inputs.length; i++){
            const input = form_inputs[i];
            if (input.type === "radio") {
                if (input.checked) data[input.name] = input.value;
                continue;
            }
            if (input.multiple) {
                data[input.id] = Array.from(input.selectedOptions).map((option)=>option.value);
                continue;
            }
            if (input.type !== "submit") data[input.id] = input.value;
        }
        let passedRecaptcha = true;
        if (sessionStorage.getItem("recaptcha-enabled") === "true") {
            const recaptchaCheckbox = window.document.getElementById(`${form.id}-captcha-checkbox`);
            // Check if either the v3 assessment passed, or they checked the v2 checkbox
            passedRecaptcha = sessionStorage.getItem("recaptcha-assessment") === "true" || recaptchaCheckbox && !!grecaptcha.getResponse(recaptchaCheckbox.dataset.widgetId);
            // If they forgot to click the checkbox, give them a chance to try again
            if (!passedRecaptcha) {
                const formIdNum = form.id.split("signals-form-").pop();
                const submitBtn = window.document.getElementById(`signals-submit-btn-${formIdNum}`);
                if (submitBtn) submitBtn.disabled = false;
            }
        }
        data["recaptcha_assessment_ok"] = passedRecaptcha;
        data["visitor_token"] = `visitor_${get_cookie(true)}_${packet_code}`;
        data["site_visitor_token"] = `visitor_${get_cookie(false)}_${packet_code}`;
        data["submission_url"] = window.location.href;
        return data;
    }
    function submitPartial(form, chatServiceUrl) {
        const formID = form.id.split("signals-form-").pop();
        const pubURL = chatServiceUrl.split("/api/")[0] + "/api/public/forms/";
        const path = `${formID}/submit/partial`;
        (0, $3ee9d18e461ecca7$export$872f4f09fb3b16a3)({
            chatServiceUrl: pubURL,
            body: {
                data: {
                    attributes: gatherFormData(form)
                }
            },
            path: path,
            raw: true
        });
    }
    function checkForms(countryCode, serviceAddress) {
        const forms = window.document.getElementsByClassName("signals-form");
        var formIDs = [];
        const baseURL = serviceAddress.split("/api/")[0] + "/api/public/forms/";
        for(let i = 0; i < forms.length; i++){
            const form = forms[i];
            const formID = form.id.split("signals-form-").pop();
            let changed = false;
            formIDs.push(formID);
            /* hubspot strips these out, so we need to add them back in if they're missing */ if (!form.getAttribute("hx-post")) {
                form.setAttribute("hx-post", `https://${baseURL}${formID}/submit`);
                changed = true;
            }
            if (!form.getAttribute("hx-swap")) {
                form.setAttribute("hx-swap", "innerHTML");
                changed = true;
            }
            if (!form.getAttribute("hx-trigger")) {
                form.setAttribute("hx-trigger", "submit");
                changed = true;
            }
            if (changed) window.htmx.process(form);
            form.addEventListener("htmx:configRequest", function(e) {
                console.log("htmx: form submission", e);
                if (!validateForm(form)) {
                    console.log("htmx: form is invalid, not submitting");
                    e.preventDefault();
                }
                e.detail.parameters = gatherFormData(form);
                e.detail.parameters["referrer"] = sessionStorage.getItem("referrer");
            });
            const form_inputs = form.elements;
            for(let j = 0; j < form_inputs.length; j++){
                const input = form_inputs[j];
                if (input.required) {
                    input.addEventListener("blur", function(e) {
                        submitPartial(form, chatServiceUrl);
                        if (!validateFieldValue(e.target.value)) createInputErr(input, "This field is required");
                        else removeInputErr(input);
                    });
                    input.addEventListener("invalid", function(e) {
                        e.preventDefault();
                        createInputErr(input, input.validationMessage);
                    });
                } else input.addEventListener("blur", function() {
                    submitPartial(form, chatServiceUrl);
                });
                if (input.id.includes("email")) {
                    var classes = input.classList;
                    if (classes.contains("block-email")) {
                        const stored_unwanted_emails = window.sessionStorage.getItem("unwanted-emails");
                        if (!stored_unwanted_emails) chat_window.postMessage({
                            type: "unwanted_emails"
                        }, "*");
                        input.addEventListener("blur", function(e) {
                            validateEmail(input, e.target.value);
                        });
                        input.addEventListener("keydown", function(e) {
                            if (e.key === "Enter") validateEmail(input, e.target.value);
                        });
                    }
                }
                if (input.id.includes("phone") && !input.classList.contains("iti__tel-input")) {
                    const iti = window.intlTelInput(input, {
                        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@21.2.4/build/js/utils.js",
                        initialCountry: countryCode
                    });
                    input.addEventListener("blur", function(e) {
                        validatePhone(input, iti, e.target.value);
                    });
                    input.addEventListener("keydown", function(e) {
                        if (e.key === "Enter") validatePhone(input, iti, e.target.value);
                    });
                    let currStyle = input.getAttribute("style");
                    if (currStyle.includes("all: ")) {
                        let s = document.createElement("style");
                        document.head.appendChild(s);
                        s.sheet.insertRule(".signals-phone-field { " + currStyle + "; box-sizing: border-box; width: 100%  }", 0);
                        input.setAttribute("style", "width: 100%;");
                    } else input.setAttribute("style", "width: 100%;");
                }
            }
        }
        return formIDs;
    }
    function fillForm(formID, formFill) {
        const form = window.document.getElementById("signals-form-" + formID);
        const params = new URLSearchParams(window.location.search);
        if (form) {
            const form_inputs = form.elements;
            for(let i = 0; i < form_inputs.length; i++){
                const input = form_inputs[i];
                if (params.has(input.id) && params.get(input.id) !== "") input.value = params.get(input.id);
                else if (formFill[input.id]) input.value = formFill[input.id];
            }
        }
    }
    function get_base_cookie_domain() {
        const host = window.location.host;
        const parts = host.split(".");
        if (parts.length <= 1) return host;
        if (parts.length > 2) return "." + parts.slice(1, parts.length).join(".");
        return "." + parts.join(".");
    }
    function hard_enable_content_mode() {
        const chat_id = "cf_" + packet_code;
        chat_el = window.document.createElement("iframe");
        chat_el_wrap = window.document.createElement("div");
        chat_el.setAttribute("id", chat_id);
        chat_el.setAttribute("title", "Chat");
        chat_el.setAttribute("style", `
      background-color: transparent;
      border: none;
      `);
        chat_el.setAttribute("frameborder", "0");
        chat_el.setAttribute("marginheight", "0");
        chat_el.setAttribute("marginwidth", "0");
        chat_el.setAttribute("scrolling", "auto");
        chat_el.setAttribute("allow", "microphone");
        chat_el.setAttribute("src", app_url);
        chat_el_wrap.appendChild(chat_el);
        parentElement.appendChild(chat_el_wrap);
        chat_window = chat_el.contentWindow;
        chatInitReady && chatInitReady(chat_el);
        return true;
    }
    function hard_enable_landing_page_mode() {
        const chat_id = "cf_" + packet_code;
        chat_el = window.document.createElement("iframe");
        chat_el_wrap = window.document.createElement("div");
        chat_el.setAttribute("id", chat_id);
        chat_el.setAttribute("title", "Chat");
        chat_el.setAttribute("style", `
      background-color: transparent;
      border: none;
      height: 100%;
      width: 100%;
      display: block;
      `);
        chat_el.setAttribute("frameborder", "0");
        chat_el.setAttribute("marginheight", "0");
        chat_el.setAttribute("marginwidth", "0");
        chat_el.setAttribute("scrolling", "auto");
        chat_el.setAttribute("allow", "microphone");
        chat_el.setAttribute("src", app_url);
        chat_el_wrap.setAttribute("style", `
      display: flex;
      height: 100%;
      width: 100%;
      justify-content: center;
    `);
        chat_el_wrap.appendChild(chat_el);
        parentElement.appendChild(chat_el_wrap);
        chat_window = chat_el.contentWindow;
        chatInitReady && chatInitReady(chat_el);
        return true;
    }
    function hard_enable() {
        const chat_id = "cf_" + packet_code;
        const chat_window_open = window.document.getElementById(chat_id);
        // If a window already opened, then do nothing
        if (chat_window_open) return false;
        let htmx_script = window.document.createElement("script");
        htmx_script.setAttribute("src", "https://unpkg.com/htmx.org@1.9.4/dist/htmx.min.js");
        let twilio_plugin = window.document.createElement("script");
        twilio_plugin.setAttribute("src", "https://cdn.jsdelivr.net/npm/intl-tel-input@21.2.4/build/js/intlTelInput.min.js");
        let twilio_link = window.document.createElement("link");
        twilio_link.setAttribute("rel", "stylesheet");
        twilio_link.setAttribute("href", "https://cdn.jsdelivr.net/npm/intl-tel-input@21.2.4/build/css/intlTelInput.css");
        window.document.head.appendChild(htmx_script);
        window.document.head.appendChild(twilio_link);
        window.document.body.appendChild(twilio_plugin);
        if (contentMode) return hard_enable_content_mode();
        else if (mode === "landing-page") return hard_enable_landing_page_mode();
        chat_el = window.document.createElement("iframe");
        chat_el.setAttribute("title", "Chat");
        chat_el_wrap = window.document.createElement("div");
        chat_el.setAttribute("id", chat_id);
        chat_el.setAttribute("style", `
      height: 1px;
      width: 1px;
      display: none;
      position: fixed;
      right: 0px;
      bottom: 0px;
      background-color: transparent;
      z-index: 1000;
      border: none;
      max-height: 700px;
      max-width: 415px;
      color-scheme: none;
      `);
        chat_el.setAttribute("frameborder", "0");
        chat_el.setAttribute("marginheight", "0");
        chat_el.setAttribute("marginwidth", "0");
        chat_el.setAttribute("scrolling", "auto");
        chat_el.setAttribute("allow", "microphone");
        chat_el.setAttribute("src", app_url);
        chat_el_wrap.setAttribute("style", `
      position: absolute;
      z-index: 10000000;
      `);
        chat_el_wrap.appendChild(chat_el);
        window.document.body.appendChild(chat_el_wrap);
        chat_window = chat_el.contentWindow;
        chatInitReady && chatInitReady(window.ChatFunnels, chat_el);
        return true;
    }
    if (!params.disabled) {
        const should_load = hard_enable();
        if (!should_load) return;
    }
    function cf_event(event_name, event_props) {
        if (!event_props) event_props = {};
        const meta = get_meta_props();
        const event_data = {
            type: "cf_events",
            attributes: {
                kind: event_name,
                plid: page_load_id,
                url: meta.loc,
                referrer: determineReferrer(),
                title: meta.title,
                tz: meta.tz,
                props: event_props
            }
        };
        chat_window.postMessage(event_data, "*");
    }
    function page_change_event() {
        if (page_change.url !== window.location.href) {
            page_change.url = window.location.href;
            page_change.referrer = determineReferrer();
            page_change.page_title = window.document.title;
            page_change.plid = page_load_id;
            chat_window.postMessage(page_change, "*");
        }
    }
    function setup_url_listener() {
        window.addEventListener("popstate", function() {
            page_change_event();
        });
    }
    function setup_scroll_listener() {
        let scroll_timeout = null;
        window.addEventListener("scroll", function() {
            const scroll_percent = get_scroll_percent();
            const last_max = max_scroll_percent;
            let instant_emit = false;
            if (scroll_percent > last_max + 6) instant_emit = true;
            if (scroll_percent > max_scroll_percent) max_scroll_percent = scroll_percent;
            if (!has_scrolled || instant_emit) cf_event("scroll", {
                sp: scroll_percent
            });
            else {
                if (scroll_timeout) {
                    clearTimeout(scroll_timeout);
                    scroll_timeout = null;
                }
                scroll_timeout = setTimeout(function() {
                    cf_event("scroll", {
                        sp: scroll_percent
                    });
                }, 400);
            }
            has_scrolled = true;
        });
    }
    function get_scroll_percent() {
        const body = document.body;
        const html = document.documentElement;
        const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const viewport_height = window.innerHeight;
        let effective_scrollable_height = height - viewport_height;
        if (effective_scrollable_height <= 0) effective_scrollable_height = 0.0001;
        const y = window.scrollY;
        if (!y) return 0;
        let sp = y / effective_scrollable_height * 100;
        sp = Math.floor(sp);
        if (Number.isNaN(sp)) return 0;
        return sp;
    }
    function get_meta_props() {
        const visible = window.document.visibilityState;
        const focus = window.document.hasFocus();
        let tzid = "";
        try {
            tzid = Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch  {}
        if (!tzid) tzid = "";
        const meta_props = {
            vs: visible,
            fs: focus,
            title: window.document.title,
            sy: window.scrollY,
            ms: max_scroll_percent,
            tz: tzid,
            loc: window.location.href
        };
        return meta_props;
    }
    function g4analytics1(data) {
        if (!ga4_params.measurementID) return;
        gtag("event", "Signals", {
            event_action: data.action,
            event_label: data.label
        });
    }
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        window.dataLayer.push(arguments);
    }
    function ga4_setup1(params) {
        if (!params.measurementID) return;
        console.log("setting up GA4");
        gtag("js", new Date());
        gtag("config", params.measurementID, {
            send_page_view: false
        });
        ga4_params = params;
    }
    function determineReferrer() {
        const sessionReferrer = sessionStorage.getItem("referrer");
        if (sessionReferrer) return sessionReferrer;
        else if (sessionReferrer == "Direct") return "";
        else {
            if (!document.referrer) (0, $3ee9d18e461ecca7$export$8a8216c44337cd5)("referrer", "Direct");
            else (0, $3ee9d18e461ecca7$export$8a8216c44337cd5)("referrer", document.referrer);
            return document.referrer;
        }
    }
    function send_activate_message() {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        const cookie_value = get_cookie(false);
        const activate_message = {
            type: "id",
            id: cookie_value,
            packet_code: packet_code,
            chatServiceUrl: chatServiceUrl,
            page_load_id: page_load_id,
            page_url: window.location.href,
            referrer: determineReferrer(),
            page_title: window.document.title,
            debug: debug,
            hide_mode: hideMode,
            mode: mode,
            submissionID: submissionID,
            auto_load_bot_id: auto_load_bot_id,
            preventCriteriaPrompts: preventCriteriaPrompts,
            supportBot: supportBot,
            screen: {
                x: width,
                y: height
            },
            identity: identity,
            meta: {},
            active_conversation_id: (0, $3ee9d18e461ecca7$export$fd98ba27f2ec095e)(`active-convo-id-${packet_code}`)
        };
        const hutk = cookie.get("hubspotutk");
        if (hutk) activate_message.meta.hutk = hutk;
        const tuid = cookie.get("tuid");
        if (tuid) activate_message.meta.tuid = tuid;
        chat_window.postMessage(activate_message, "*");
    }
    function addCaptchaCheckbox(captchaKey) {
        const forms = window.document.querySelectorAll('[id^="signals-form-"]');
        forms.forEach((form)=>{
            const captchaCheckbox = window.document.createElement("div");
            captchaCheckbox.setAttribute("class", "g-recaptcha");
            captchaCheckbox.setAttribute("data-sitekey", captchaKey);
            captchaCheckbox.setAttribute("id", `${form.id}-captcha-checkbox`);
            const submitDiv = form.getElementsByClassName("signals-form-submit")[0];
            form.insertBefore(captchaCheckbox, submitDiv);
            // Used to get the response when submitting
            captchaCheckbox.setAttribute("data-widget-id", grecaptcha.render(`${form.id}-captcha-checkbox`, {
                "sitekey": captchaKey
            }));
        });
    }
    // Creates an assessment for the client and store result in session storage
    //
    // @param {string} captchaKey - The reCAPTCHA key to use for the assessment
    function createAssessment(captchaV3Key, captchaV2Key) {
        const recaptchaAssessment = sessionStorage.getItem("recaptcha-assessment");
        if (recaptchaAssessment !== null) {
            if (recaptchaAssessment === "false") addCaptchaCheckbox(captchaV2Key);
            else addCaptchaNoticeToForms();
            return;
        }
        grecaptcha.enterprise.ready(async ()=>{
            const token = await grecaptcha.enterprise.execute(captchaV3Key, {
                action: "load"
            });
            try {
                await (0, $3ee9d18e461ecca7$export$872f4f09fb3b16a3)({
                    chatServiceUrl: chatServiceUrl.split("/api/")[0],
                    body: {
                        data: {
                            attributes: {
                                token: token,
                                action: "load"
                            }
                        }
                    },
                    path: "/api/core/captcha/assessment"
                }).then((response)=>{
                    sessionStorage.setItem("recaptcha-assessment", response.ok);
                    if (!response.ok) addCaptchaCheckbox(captchaV2Key);
                    else addCaptchaNoticeToForms();
                });
            } catch (error) {
                console.error("Error during captcha assessment: ", error);
            }
        });
    }
    // This function adds a notice to the form that reCAPTCHA is being used.
    // This allows us to remove the reCAPTCHA logo from the bottom right of
    // the page. See https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge.-what-is-allowed
    function addCaptchaNoticeToForms() {
        const forms = window.document.querySelectorAll('[id^="signals-form-"]');
        forms.forEach((form)=>{
            const recaptchaNotice = window.document.createElement("div");
            recaptchaNotice.setAttribute("class", "recaptcha-notice");
            recaptchaNotice.setAttribute("style", "width: 100%; opacity: 0.5; font-size: 0.8em;");
            const noticeBegin = window.document.createElement("span");
            noticeBegin.textContent = "This form is protected by reCAPTCHA and the Google ";
            const privacyPolicyLink = window.document.createElement("a");
            privacyPolicyLink.href = "https://policies.google.com/privacy";
            privacyPolicyLink.textContent = "Privacy Policy";
            const noticeMiddle = window.document.createElement("span");
            noticeMiddle.textContent = " and ";
            const termsOfServiceLink = window.document.createElement("a");
            termsOfServiceLink.href = "https://policies.google.com/terms";
            termsOfServiceLink.textContent = "Terms of Service";
            const noticeEnd = window.document.createElement("span");
            noticeEnd.textContent = " apply.";
            recaptchaNotice.appendChild(noticeBegin);
            recaptchaNotice.appendChild(privacyPolicyLink);
            recaptchaNotice.appendChild(noticeMiddle);
            recaptchaNotice.appendChild(termsOfServiceLink);
            recaptchaNotice.appendChild(noticeEnd);
            form.appendChild(recaptchaNotice);
        });
    }
    function recaptchaInstall(captchaV3Key, captchaV2Key) {
        const recaptcha_script = window.document.createElement("script");
        recaptcha_script.src = `https://www.google.com/recaptcha/enterprise.js?render=${captchaV3Key}`;
        recaptcha_script.async = true;
        recaptcha_script.defer = true;
        const recaptcha_v2_script = window.document.createElement("script");
        recaptcha_v2_script.src = "https://www.google.com/recaptcha/api.js";
        recaptcha_v2_script.async = true;
        recaptcha_v2_script.defer = true;
        const recaptcha_logo_style = window.document.createElement("style");
        recaptcha_logo_style.innerHTML = ".grecaptcha-badge { visibility: hidden; }";
        recaptcha_v2_script.onerror = ()=>{
            console.error("Failed to load the reCAPTCHA v2 script");
        };
        recaptcha_script.onload = ()=>{
            createAssessment(captchaV3Key, captchaV2Key);
        };
        recaptcha_script.onerror = ()=>{
            console.error("Failed to load the reCAPTCHA script");
        };
        window.document.head.appendChild(recaptcha_v2_script);
        window.document.head.appendChild(recaptcha_script);
        window.document.head.appendChild(recaptcha_logo_style);
    }
    function activate() {
        has_activated = true;
        const blocked = isParticipantBlocked();
        if (blocked) return;
        page_load_id = (0, $3ee9d18e461ecca7$export$6473347ac50c95ee)(8);
        send_activate_message();
        // Set up anything that needs postMessage to work here
        setup_url_listener();
        setup_scroll_listener();
        chatCompletelyReady && chatCompletelyReady(window.ChatFunnels, chat_el);
    }
    function getURLCookie(packetCode) {
        const params = new URLSearchParams(window.location.search);
        const cfid = params.get("cfid");
        if (cfid) {
            const parts = cfid.split("_");
            if (parts.length === 2 && packetCode === parts[1]) return parts[0];
        }
        return null;
    }
    function get_cookie(formCookie) {
        const suffix = formCookie ? "_cffid" : "_cfid";
        const codePrefix = packet_code.slice(0, 16);
        const prefixedCookieName = codePrefix + suffix;
        const cookieValue = cookie.get(suffix);
        let prefixedCookieValue = cookie.get(prefixedCookieName);
        if (!prefixedCookieValue) {
            if (cookieValue) return cookieValue;
            const urlCookie = getURLCookie(packet_code);
            if (urlCookie) prefixedCookieValue = urlCookie;
            else prefixedCookieValue = (0, $3ee9d18e461ecca7$export$6473347ac50c95ee)(64);
            cookie.set(prefixedCookieName, prefixedCookieValue, {
                sameSite: "lax",
                path: "/",
                domain: get_base_cookie_domain(),
                expires: 730,
                secure: true
            });
            let loadedCookie = cookie.get(prefixedCookieName);
            if (loadedCookie !== prefixedCookieValue) {
                // https://stackoverflow.com/questions/47419602/setting-a-cookie-on-github-io-domain-in-javascript
                // https://publicsuffix.org/
                cookie.set(prefixedCookieName, prefixedCookieValue, {
                    sameSite: "lax",
                    path: "/",
                    expires: 730,
                    secure: true
                });
                loadedCookie = cookie.get(prefixedCookieName);
            }
        }
        return prefixedCookieValue;
    }
    function remove_cf_cookie() {
        const codePrefix = packet_code.slice(0, 16);
        const prefixedCookieName = codePrefix + "_cfid";
        cookie.remove(prefixedCookieName);
    }
    function isParticipantBlocked() {
        const userAgent = window.navigator.userAgent;
        if (userAgent.includes("Headless")) return true;
        const prefixed_cookie_name = packet_code.slice(0, 16) + "_cf_blocked";
        const prefixed_cookie_value = cookie.get(prefixed_cookie_name);
        return prefixed_cookie_value;
    }
    function setBlockedCookie(expiration) {
        const expiredDate = new Date(expiration);
        const milliseconds = 86400000;
        const days = parseInt((expiredDate - new Date()) / milliseconds);
        const prefixed_cookie_name = packet_code.slice(0, 16) + "_cf_blocked";
        cookie.set(prefixed_cookie_name, true, {
            sameSite: "lax",
            path: "/",
            expires: days,
            secure: true
        });
    }
    function attach_click_to_el(els, callback) {
        for(let i = 0; i < els.length; i++){
            const el = els[i];
            el.addEventListener("click", callback);
        }
    }
    function set_triggers(params) {
        triggers.fragments = params.bot_fragments;
        triggers.selectors = params.bot_selectors;
        for(const selector in triggers.selectors){
            if (!triggers.selectors.hasOwnProperty(selector)) continue;
            const botID = triggers.selectors[selector];
            const els = document.querySelectorAll(selector);
            attach_click_to_el(els, function() {
                chat_window.postMessage({
                    type: "bot_trigger_id",
                    botID: botID
                }, "*");
            });
        }
        fragment_check();
    }
    function fragment_check() {
        let hash = location.hash;
        if (hash) {
            hash = hash.substring(1);
            if (triggers.fragments && triggers.fragments[hash]) {
                const botID = triggers.fragments[hash];
                chat_window.postMessage({
                    type: "bot_trigger_id",
                    botID: botID
                }, "*");
            }
        }
    }
    window.addEventListener("popstate", function() {
        fragment_check();
    }, false);
    const PageTitleNotification = {
        Vars: {
            OriginalTitle: siteTitle,
            Interval: null
        },
        On: function(notification, intervalSpeed) {
            this.Vars.Interval = setInterval(function() {
                window.document.title = this.Vars.OriginalTitle === window.document.title ? notification : this.Vars.OriginalTitle;
            }, intervalSpeed || 500);
        },
        Off: function() {
            clearInterval(this.Vars.Interval);
            this.Vars.Interval = null;
            document.title = this.Vars.OriginalTitle;
        }
    };
    let visibilityChange;
    if (typeof document.hidden !== "undefined") visibilityChange = "visibilitychange";
    else if (typeof document.msHidden !== "undefined") visibilityChange = "msvisibilitychange";
    else if (typeof document.webkitHidden !== "undefined") visibilityChange = "webkitvisibilitychange";
    document.addEventListener(visibilityChange, handleVisibilityChange, false);
    if (window.visualViewport) {
        const vp = ()=>{
            const newVisualViewportSize = {
                height: window.visualViewport.height,
                offsetTop: window.visualViewport.offsetTop
            };
            if (newVisualViewportSize.height !== visualViewportSize.height || newVisualViewportSize.offsetTop !== visualViewportSize.offsetTop) {
                visualViewportSize = newVisualViewportSize;
                chat_window && chat_window.postMessage({
                    type: "visualviewport_size",
                    height: window.visualViewport.height,
                    offsetTop: window.visualViewport.offsetTop
                }, "*");
            }
        };
        window.visualViewport.addEventListener("resize", vp);
        window.visualViewport.addEventListener("scroll", ()=>{
            if (visualViewportScrollTimeout) return;
            visualViewportScrollTimeout = setTimeout(()=>{
                visualViewportScrollTimeout = null;
                vp();
            }, 250);
        });
        setInterval(vp, 10000);
    }
    function handleVisibilityChange() {
        PageTitleNotification.Off();
    }
    window.addEventListener("message", (message)=>{
        if (message.source !== chat_window) return;
        const data = message.data;
        switch(data.command){
            case "resize":
                if (!contentMode) {
                    chat_el.style.width = data.params.x;
                    chat_el.style.height = data.params.y;
                    chat_el.style.minHeight = data.params.minHeight;
                    chat_el.style.maxWidth = data.params.maxWidth;
                    chat_el.style.maxHeight = data.params.maxHeight;
                }
                break;
            case "block_participant":
                setBlockedCookie(data.params.expired_timestamp);
                break;
            case "hide":
                chat_el.style.display = "none";
                break;
            case "show":
                chat_el.style.display = "block";
                break;
            case "appLoaded":
                params.appLoaded && params.appLoaded(window.ChatFunnels, chat_el);
                break;
            case "webcall:agent_start_talking":
            case "webcall:agent_stop_talking":
            case "webcall:call_ended":
            case "webcall:update":
            case "webcall:metadata":
            case "webcall:audio":
                document.dispatchEvent(new CustomEvent("signals:webcall", {
                    detail: {
                        evt_type: data.command,
                        evt_data: data
                    }
                }));
                break;
            case "activate":
                activate(data.params);
                break;
            case "set_triggers":
                set_triggers(data.params);
                break;
            case "new_message":
                if (window.document.hidden) {
                    chat_window.postMessage({
                        type: "play_sound"
                    }, "*");
                    if (!PageTitleNotification.Vars.Interval) PageTitleNotification.On("New Message!");
                }
                break;
            case "ga_setup":
                ga4_setup1(data.params);
                break;
            case "ga":
                g4analytics1(data.params);
                break;
            case "welcome_packet":
                if (data.params.recaptchaV3Key && data.params.recaptchaV2Key) {
                    sessionStorage.setItem("recaptcha-enabled", "true");
                    recaptchaInstall(data.params.recaptchaV3Key, data.params.recaptchaV2Key);
                }
                var formIDs = checkForms(data.params.countryCode, chatServiceUrl);
                if (formIDs.length > 0) for(let i = 0; i < formIDs.length; i++)chat_window.postMessage({
                    type: "form_fill",
                    form_id: formIDs[i]
                }, "*");
                break;
            case "unwanted_emails":
                (0, $3ee9d18e461ecca7$export$8a8216c44337cd5)("unwanted-emails", JSON.stringify(data.params));
                break;
            case "form_fill":
                fillForm(data.params.id, data.params.form_fill);
                if (data.params.form_fill["always_new"]) remove_cf_cookie();
                break;
            default:
                break;
        }
    });
    return {
        identify: function(data) {
            identity.first_name = data.first_name;
            identity.last_name = data.last_name;
            identity.email = data.email;
            identity.company_name = data.company_name;
            identity.phone = data.phone;
            identity.unique_id = data.unique_id;
            if (has_activated) send_activate_message({});
        },
        _internal: {
            hard_enable: hard_enable,
            loadBot: function(botID) {
                chat_window.postMessage({
                    type: "bot_trigger_id",
                    botID: botID
                }, "*");
            },
            startVoiceCall: function(args) {
                let agentID = null;
                let direct = false;
                if (args) {
                    if (args?.agentID) agentID = args.agentID;
                    if (args?.direct) direct = args.direct;
                    else direct = false;
                }
                chat_window.postMessage({
                    type: "start_voice_call",
                    agentID: agentID,
                    direct: direct
                }, "*");
            },
            previewBot: function(botID) {
                chat_window.postMessage({
                    type: "bot_trigger_id",
                    botID: botID,
                    preview: true
                });
            },
            closeBots: function() {
                chat_el.style.display = "none";
                chat_window.postMessage({
                    type: "open_state",
                    state: false
                }, "*");
            },
            hard_disable: function() {
                chat_el_wrap.parentNode.removeChild(chat_el_wrap);
                chat_el_wrap = null;
                chat_el = null;
                chat_window = null;
            },
            createChatWithUserId: function(userID) {
                chat_window.postMessage({
                    type: "conversation_by_user_id",
                    userID: userID
                }, "*");
            }
        }
    };
}(cf_chat_loader()) // eslint-disable-line no-undef
;
window.SignalsSDK = {
    startVoiceCall: (agentID, direct)=>{
        window.ChatFunnels._internal.startVoiceCall({
            agentID: agentID,
            direct: direct
        });
    }
};
document.body.addEventListener("Signals.showModal", function(evt) {
    console.log("received new event", {
        detail: evt.detail
    });
    window.SignalsForm.showModal(evt.detail);
});
document.body.addEventListener("redirectUrlReceived", function(evt) {
    var redirectUrl = evt.detail.redirect_url;
    if (redirectUrl) window.redirectUrl = redirectUrl;
});
window.SignalsForm = {
    loadBot: (botID, botType, submissionID)=>{
        const params = window.cf_chat_loader();
        (0, $3ee9d18e461ecca7$export$8a8216c44337cd5)(`formbotactive-convo-id-${params.packet_code}`, "");
        document.getElementById("signals-modal-content").style.height = "650px";
        document.getElementById("signals-modal-content").style.width = "600px";
        document.getElementById("signals-modal-content").style.padding = "0px";
        document.getElementById("signals-modal-content").style.paddingTop = "0px";
        document.getElementById("signals-modal-content").style.overflowX = "hidden";
        document.getElementById("signals-modal-content").style.overflowY = "hidden";
        document.getElementById("signals-modal-content").style.maxHeight = botType === "book-meeting" ? "525px" : "584px";
        document.getElementById("signals-modal-content").innerHTML = "";
        window.SignalsForm.init({
            ...params,
            mode: `modal-${botType}`,
            parentElement: document.getElementById("signals-modal-content"),
            bot_id: botID,
            submissionID: submissionID,
            preventCriteriaPrompts: true,
            chatInitReady: (chatEl)=>{
                chatEl.style.height = "100%";
                chatEl.style.width = "100%";
            }
        });
    },
    showModal: (params)=>{
        let d = document.getElementById("signals-form-modal");
        let append = false;
        if (!d) {
            append = true;
            d = document.createElement("div");
            d.setAttribute("id", "signals-form-modal");
            let css = document.createElement("style");
            css.innerHTML = `
#signals-modal-content .ql-align-right {
	text-align: right;
}
#signals-modal-content .ql-align-center {
	text-align: center;
}
#signals-modal-content .ql-align-left {
	text-align: left;
}`;
            document.getElementsByTagName("head")[0].appendChild(css);
        }
        let buttons = "";
        let buttonMargin = 0;
        let buttonColor = params?.button_color;
        if (params?.live_chat_bot_id && params?.book_meeting_bot_id) buttonMargin = 2;
        if (params?.live_chat_bot_id) buttons += `<button id="signals-live-chat-button" style="color: white; text-align: center; width: 100%; background-color: ${buttonColor}; font-size: 16px; font-family: Arial; font-weight: bold; padding: 5px; height: 34px; box-shadow: 0px 3px 6px #00000029; letter-spacing: 0.2px; border-radius: 5px; opacity: 1;margin-right: ${buttonMargin}px;border: none;">${params.live_chat_button}</button>`;
        if (params?.book_meeting_bot_id) buttons += `<button id="signals-book-meeting-button" style="color: white; text-align: center; width: 100%; background-color: ${buttonColor}; font-size: 16px; font-family: Arial; font-weight: bold; padding: 5px; height: 34px; box-shadow: 0px 3px 6px #00000029; letter-spacing: 0.2px; border-radius: 5px; opacity: 1;margin-left: ${buttonMargin}px;border: none;">${params.book_meeting_button}</button>`;
        let avatars = "";
        if (params?.avatars) for(let i = 0; i < params.avatars.length; i++)avatars += `<div style="width: 1.5em;height: 1.5em;font-size: 25px; background-color: rgb(204, 204, 204);overflow: hidden; position: relative; left: -10px;border: 2px solid #FFF;border-radius: 50%;margin-left: -5px;z-index: ${100000010 - i}";"><img alt="" style="height: 41px; width: 41px;" src="${params.avatars[i]}"></div>`;
        d.innerHTML = `
    <div id="signals-modal-content" style="all: unset; font-family: 'Arial'; display:block; background-color: #fefefe; padding: 20px; border-radius: 7px; overflow: auto; border: 1px solid #888; width: 450px; max-height: 320px;">
      <div style="display: flex;justify-content: space-between;">
        <div style="text-align: left; font-size: 25px; letter-spacing: 0px; color: #000000; opacity: 1;">${params.header}</div>
        <div style="display: flex;">
          ${avatars}
          <div style="cursor: pointer" id="signals-modal-close">
            <img src="https://cdn.jsdelivr.net/gh/chatfunnels/cdn@main/icon-material-close.svg" />
          </div>
        </div>
      </div>
      <div id="signals-prompt-body"style="text-align: left; font-size: 18px; margin-top: 3px; letter-spacing: 0.1px; color: #000000BF; opacity: 1;height: auto" hx-trigger="load" hx-get="${params.body_url}"></div>
      <div style="display: flex">
        ${buttons}
      </div>
    </div>
    `;
        d.setAttribute("style", "display: none; position: fixed; z-index: 10000002; left: 0; top: 0; width: 100%; height: 100%; background-color: rgb(0,0,0); background-color: rgba(0,0,0,0.4); place-items: center");
        if (append) document.body.appendChild(d);
        document.getElementById("signals-modal-close").onclick = function() {
            d.style.display = "none";
            if (window.redirectUrl) window.location.href = window.redirectUrl;
        };
        if (params.live_chat_bot_id) document.getElementById("signals-live-chat-button")?.addEventListener("click", function() {
            window.SignalsForm.loadBot(params.live_chat_bot_id, "live-chat", params.submission_id);
        });
        if (params.book_meeting_bot_id) document.getElementById("signals-book-meeting-button")?.addEventListener("click", function() {
            window.SignalsForm.loadBot(params.book_meeting_bot_id, "book-meeting", params.submission_id);
        });
        window.htmx.process(d);
        d.style.display = "grid";
    },
    init: (params)=>{
        let chat_window;
        let chat_el;
        let chat_el_wrap;
        let has_activated = false;
        const packet_code = params.packet_code;
        let app_url = params.app_url;
        let chatServiceUrl = params.service_address;
        if (packet_code === "cb6dbb20bfbeee14b104c353779772ef78d549b2") {
            app_url = "https://beta.chatfunnels.com/chat-client/";
            chatServiceUrl = "beta.chatfunnels.com/api/chat-service/a";
        }
        const debug = params.debug || false;
        const siteTitle = window.document.title;
        const hideMode = params.hideMode || false;
        let page_load_id = null;
        const identity = {
            first_name: "",
            last_name: "",
            email: "",
            unique_id: null
        };
        let visualViewportSize = {};
        let visualViewportScrollTimeout = null;
        const mode = params.mode || "normal";
        const chatInitReady = params.chatInitReady || (()=>{});
        const auto_load_bot_id = params.bot_id;
        const submissionID = params.submissionID;
        const parentElement = params.parentElement;
        const chatCompletelyReady = params.chatCompletelyReady;
        const preventCriteriaPrompts = params.preventCriteriaPrompts || false;
        /**
      * Until "cookie end" comment, license:
      *
      * Copyright (c) Florian Hartmann, https://github.com/florian
      * Permission is hereby granted, free of charge, to any person obtaining
      * a copy of this software and associated documentation files (the
      * "Software"), to deal in the Software without restriction, including
      * without limitation the rights to use, copy, modify, merge, publish,
      * distribute, sublicense, and/or sell copies of the Software, and to
      * permit persons to whom the Software is furnished to do so, subject to
      * the following conditions:
      *
      * The above copyright notice and this permission notice shall be
      * included in all copies or substantial portions of the Software.
      *
      * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
      * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
      * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
      * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
      * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
      * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
      * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
      **/ // eslint-disable-next-line
        const cookielib = function() {
            "use strict";
            var e = function() {
                return e.get.apply(e, arguments);
            };
            var t = e.utils = {
                isArray: Array.isArray || function(e) {
                    return Object.prototype.toString.call(e) === "[object Array]";
                },
                isPlainObject: function(e) {
                    return !!e && Object.prototype.toString.call(e) === "[object Object]";
                },
                toArray: function(e) {
                    return Array.prototype.slice.call(e);
                },
                getKeys: Object.keys || function(e) {
                    var t = [];
                    var r = "";
                    for(r in e)e.hasOwnProperty(r) && t.push(r);
                    return t;
                },
                encode: function(e) {
                    return String(e).replace(/[,;"\\=\s%]/g, function(e) {
                        return encodeURIComponent(e);
                    });
                },
                decode: function(e) {
                    return decodeURIComponent(e);
                },
                retrieve: function(e, t) {
                    return e == null ? t : e;
                }
            };
            return e.defaults = {}, e.expiresMultiplier = 86400, e.set = function(e, r, i) {
                if (t.isPlainObject(e)) for(var n in e)e.hasOwnProperty(n) && this.set(n, e[n], r);
                else {
                    var o = void 0 !== (i = t.isPlainObject(i) ? i : {
                        expires: i
                    }).expires ? i.expires : this.defaults.expires || "";
                    var s = typeof o;
                    s === "string" && o !== "" ? o = new Date(o) : s === "number" && (o = new Date(+new Date() + 1e3 * this.expiresMultiplier * o)), o !== "" && "toUTCString" in o && (o = ";expires=" + o.toUTCString());
                    var a = i.path || this.defaults.path;
                    a = a ? ";path=" + a : "";
                    var u = i.domain || this.defaults.domain;
                    u = u ? ";domain=" + u : "";
                    var c = i.secure || this.defaults.secure ? ";secure" : "";
                    !1 === i.secure && (c = "");
                    var l = i.sameSite || this.defaults.sameSite;
                    l = l ? ";SameSite=" + l : "", i.sameSite === null && (l = ""), document.cookie = t.encode(e) + "=" + t.encode(r) + o + a + u + c + l;
                }
                return this;
            }, e.setDefault = function(r, i, n) {
                if (t.isPlainObject(r)) {
                    for(var o in r)void 0 === this.get(o) && this.set(o, r[o], i);
                    return e;
                }
                if (void 0 === this.get(r)) return this.set.apply(this, arguments);
            }, e.remove = function(e) {
                for(var r = 0, i = (e = t.isArray(e) ? e : t.toArray(arguments)).length; r < i; r++)this.set(e[r], "", -1);
                return this;
            }, e.removeSpecific = function(e, r) {
                if (!r) return this.remove(e);
                e = t.isArray(e) ? e : [
                    e
                ], r.expires = -1;
                for(var i = 0, n = e.length; i < n; i++)this.set(e[i], "", r);
                return this;
            }, e.empty = function() {
                return this.remove(t.getKeys(this.all()));
            }, e.get = function(e, r) {
                var i = this.all();
                if (t.isArray(e)) {
                    for(var n = {}, o = 0, s = e.length; o < s; o++){
                        var a = e[o];
                        n[a] = t.retrieve(i[a], r);
                    }
                    return n;
                }
                return t.retrieve(i[e], r);
            }, e.all = function() {
                if (document.cookie === "") return {};
                for(var e = document.cookie.split("; "), r = {}, i = 0, n = e.length; i < n; i++){
                    var o = e[i].split("=");
                    var s = t.decode(o.shift());
                    var a = t.decode(o.join("="));
                    r[s] = a;
                }
                return r;
            }, e.enabled = function() {
                if (navigator.cookieEnabled) return !0;
                var t = e.set("_", "_").get("_") === "_";
                return e.remove("_"), t;
            }, e;
        };
        const cookie = cookielib();
        /* cookie end */ function get_base_cookie_domain() {
            const host = window.location.host;
            const parts = host.split(".");
            if (parts.length <= 1) return host;
            if (parts.length > 2) return "." + parts.slice(1, parts.length).join(".");
            return "." + parts.join(".");
        }
        function _hard_enable() {
            const chat_id = "cff_" + packet_code;
            chat_el = window.document.createElement("iframe");
            chat_el.setAttribute("title", "Chat");
            chat_el_wrap = window.document.createElement("div");
            chat_el.setAttribute("id", chat_id);
            chat_el.setAttribute("style", `
      background-color: transparent;
      border: none;
      height: 100%;
      width: 100%;
      display: block;
      `);
            chat_el.setAttribute("frameborder", "0");
            chat_el.setAttribute("marginheight", "0");
            chat_el.setAttribute("marginwidth", "0");
            chat_el.setAttribute("scrolling", "auto");
            chat_el.setAttribute("allow", "microphone");
            chat_el.setAttribute("src", app_url);
            chat_el_wrap.setAttribute("style", `
      display: flex;
      height: 100%;
      width: 100%;
      justify-content: center;
    `);
            chat_el_wrap.appendChild(chat_el);
            parentElement.appendChild(chat_el_wrap);
            chat_window = chat_el.contentWindow;
            chatInitReady && chatInitReady(chat_el);
            return true;
        }
        function hard_enable() {
            /* doesn't apply to form bots?
        const chat_id = 'cff_' + packet_code
        const chat_window_open = window.document.getElementById(chat_id)
  
        // If a window already opened, then do nothing
        if (chat_window_open) {
          return false
        }
        */ return _hard_enable();
        }
        hard_enable();
        function determineReferrer() {
            const sessionReferrer = sessionStorage.getItem("referrer");
            if (sessionReferrer) return sessionReferrer;
            else if (sessionReferrer == "Direct") return "";
            else {
                if (!document.referrer) (0, $3ee9d18e461ecca7$export$8a8216c44337cd5)("referrer", "Direct");
                else (0, $3ee9d18e461ecca7$export$8a8216c44337cd5)("referrer", document.referrer);
                return document.referrer;
            }
        }
        function send_activate_message() {
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            const cookie_value = get_cookie(true);
            const activate_message = {
                type: "id",
                id: cookie_value,
                prefix: "formbot",
                packet_code: packet_code,
                chatServiceUrl: chatServiceUrl,
                page_load_id: page_load_id,
                page_url: window.location.href,
                referrer: determineReferrer(),
                page_title: window.document.title,
                debug: debug,
                hide_mode: hideMode,
                mode: mode,
                auto_load_bot_id: auto_load_bot_id,
                submissionID: submissionID,
                preventCriteriaPrompts: preventCriteriaPrompts,
                supportBot: false,
                screen: {
                    x: width,
                    y: height
                },
                identity: identity,
                meta: {},
                active_conversation_id: (0, $3ee9d18e461ecca7$export$fd98ba27f2ec095e)(`formbotactive-convo-id-${packet_code}`)
            };
            const hutk = cookie.get("hubspotutk");
            if (hutk) activate_message.meta.hutk = hutk;
            const tuid = cookie.get("tuid");
            if (tuid) activate_message.meta.tuid = tuid;
            chat_window.postMessage(activate_message, "*");
        }
        function activate() {
            has_activated = true;
            const blocked = isParticipantBlocked();
            if (blocked) return;
            page_load_id = (0, $3ee9d18e461ecca7$export$6473347ac50c95ee)(8);
            send_activate_message();
            // Set up anything that needs postMessage to work here
            chatCompletelyReady && chatCompletelyReady(window.SignalsForm, chat_el);
        }
        function getURLCookie(packetCode) {
            const params = new URLSearchParams(window.location.search);
            const cfid = params.get("cfid");
            if (cfid) {
                const parts = cfid.split("_");
                if (parts.length === 2 && packetCode === parts[1]) return parts[0];
            }
            return null;
        }
        function get_cookie(formCookie) {
            const suffix = formCookie ? "_cffid" : "_cfid";
            const codePrefix = packet_code.slice(0, 16);
            const prefixedCookieName = codePrefix + suffix;
            const cookieValue = cookie.get(suffix);
            let prefixedCookieValue = cookie.get(prefixedCookieName);
            if (!prefixedCookieValue) {
                if (cookieValue) return cookieValue;
                const urlCookie = getURLCookie(packet_code);
                if (urlCookie) prefixedCookieValue = urlCookie;
                else prefixedCookieValue = (0, $3ee9d18e461ecca7$export$6473347ac50c95ee)(64);
                cookie.set(prefixedCookieName, prefixedCookieValue, {
                    sameSite: "lax",
                    path: "/",
                    domain: get_base_cookie_domain(),
                    expires: 730,
                    secure: true
                });
                let loadedCookie = cookie.get(prefixedCookieName);
                if (loadedCookie !== prefixedCookieValue) {
                    // https://stackoverflow.com/questions/47419602/setting-a-cookie-on-github-io-domain-in-javascript
                    // https://publicsuffix.org/
                    cookie.set(prefixedCookieName, prefixedCookieValue, {
                        sameSite: "lax",
                        path: "/",
                        expires: 730,
                        secure: true
                    });
                    loadedCookie = cookie.get(prefixedCookieName);
                }
            }
            return prefixedCookieValue;
        }
        function isParticipantBlocked() {
            const userAgent = window.navigator.userAgent;
            if (userAgent.includes("Headless")) return true;
            const prefixed_cookie_name = packet_code.slice(0, 16) + "_cf_blocked";
            const prefixed_cookie_value = cookie.get(prefixed_cookie_name);
            return prefixed_cookie_value;
        }
        function setBlockedCookie(expiration) {
            const expiredDate = new Date(expiration);
            const milliseconds = 86400000;
            const days = parseInt((expiredDate - new Date()) / milliseconds);
            const prefixed_cookie_name = packet_code.slice(0, 16) + "_cf_blocked";
            cookie.set(prefixed_cookie_name, true, {
                sameSite: "lax",
                path: "/",
                expires: days,
                secure: true
            });
        }
        const PageTitleNotification = {
            Vars: {
                OriginalTitle: siteTitle,
                Interval: null
            },
            On: function(notification, intervalSpeed) {
                this.Vars.Interval = setInterval(function() {
                    window.document.title = this.Vars.OriginalTitle === window.document.title ? notification : this.Vars.OriginalTitle;
                }, intervalSpeed || 500);
            },
            Off: function() {
                clearInterval(this.Vars.Interval);
                this.Vars.Interval = null;
                document.title = this.Vars.OriginalTitle;
            }
        };
        let visibilityChange;
        if (typeof document.hidden !== "undefined") visibilityChange = "visibilitychange";
        else if (typeof document.msHidden !== "undefined") visibilityChange = "msvisibilitychange";
        else if (typeof document.webkitHidden !== "undefined") visibilityChange = "webkitvisibilitychange";
        document.addEventListener(visibilityChange, handleVisibilityChange, false);
        if (window.visualViewport) {
            const vp = ()=>{
                const newVisualViewportSize = {
                    height: window.visualViewport.height,
                    offsetTop: window.visualViewport.offsetTop
                };
                if (newVisualViewportSize.height !== visualViewportSize.height || newVisualViewportSize.offsetTop !== visualViewportSize.offsetTop) {
                    visualViewportSize = newVisualViewportSize;
                    chat_window && chat_window.postMessage({
                        type: "visualviewport_size",
                        height: window.visualViewport.height,
                        offsetTop: window.visualViewport.offsetTop
                    }, "*");
                }
            };
            window.visualViewport.addEventListener("resize", vp);
            window.visualViewport.addEventListener("scroll", ()=>{
                if (visualViewportScrollTimeout) return;
                visualViewportScrollTimeout = setTimeout(()=>{
                    visualViewportScrollTimeout = null;
                    vp();
                }, 250);
            });
            setInterval(vp, 10000);
        }
        function handleVisibilityChange() {
            PageTitleNotification.Off();
        }
        window.addEventListener("message", (message)=>{
            if (message.source !== chat_window) return;
            const data = message.data;
            if (data.command === "resize" && !mode.startsWith("modal") && mode !== "content" && mode !== "content-with-header") {
                chat_el.style.width = data.params.x;
                chat_el.style.height = data.params.y;
                chat_el.style.minHeight = data.params.minHeight;
                chat_el.style.maxWidth = data.params.maxWidth;
                chat_el.style.maxHeight = data.params.maxHeight;
            } else if (data.command === "block_participant") setBlockedCookie(data.params.expired_timestamp);
            else if (data.command === "hide") chat_el.style.display = "none";
            else if (data.command === "show") chat_el.style.display = "block";
            else if (data.command === "appLoaded") params.appLoaded && params.appLoaded(window.SignalsForm, chat_el);
            else if (data.command === "activate") activate(data.params);
            else if (data.command === "signals-modal-close") {
                document.getElementById("signals-form-modal").style.display = "none";
                if (window.redirectUrl) window.location.href = window.redirectUrl;
            } else if (data.command === "new_message") {
                if (window.document.hidden) {
                    chat_window.postMessage({
                        type: "play_sound"
                    }, "*");
                    if (!PageTitleNotification.Vars.Interval) PageTitleNotification.On("New Message!");
                }
            } else if (data.command === "ga_setup") ga4_setup(data.params);
            else if (data.command === "ga") g4analytics(data.params);
        });
        return {
            identify: function(data) {
                identity.first_name = data.first_name;
                identity.last_name = data.last_name;
                identity.email = data.email;
                identity.company_name = data.company_name;
                identity.phone = data.phone;
                identity.unique_id = data.unique_id;
                if (has_activated) send_activate_message({});
            },
            _internal: {
                hard_enable: hard_enable,
                loadBot: function(botID, submissionID) {
                    chat_window.postMessage({
                        type: "bot_trigger_id",
                        botID: botID,
                        submissionID: submissionID
                    }, "*");
                },
                startVoiceCall: function(args) {
                    let agentID = null;
                    if (args && args?.agentID) agentID = args.agentID;
                    chat_window.postMessage({
                        type: "start_voice_call",
                        agentID: agentID
                    }, "*");
                },
                previewBot: function(botID) {
                    chat_window.postMessage({
                        type: "bot_trigger_id",
                        botID: botID,
                        preview: true
                    });
                },
                closeBots: function() {
                    chat_el.style.display = "none";
                    chat_window.postMessage({
                        type: "open_state",
                        state: false
                    }, "*");
                },
                hard_disable: function() {
                    chat_el_wrap.parentNode.removeChild(chat_el_wrap);
                    chat_el_wrap = null;
                    chat_el = null;
                    chat_window = null;
                },
                createChatWithUserId: function(userID) {
                    chat_window.postMessage({
                        type: "conversation_by_user_id",
                        userID: userID
                    }, "*");
                }
            }
        };
    }
} // FOR TESTING setTimeout(() => {window.SignalsForm.showModal()}, 1000)
;

})();
//# sourceMappingURL=chat-loader.js.map
